module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/analysis-approver/component/analysis-approver/analysis-approver.component.scss
// module id = ./src/app/analysis-approver/component/analysis-approver/analysis-approver.component.scss
// module chunks = main